import {
    addExecuteQuery,
} from 'ntnu-react/util/sp';

import {
    FIELD_OPTION,
    FIELD_OPTION_ERROR,
} from '../constants/actions';

export function getFieldOptions(fieldName) {
    return (dispatch) => {
        if(__DEV__){
            return dispatch({
                type: FIELD_OPTION,
                payload: require('../mock/proposal.json'),
            });
        }
        window.SP.SOD.executeFunc("sp.js", "SP.ClientContext", () => {
            const ctx = window.SP.ClientContext.get_current();
            addExecuteQuery();
            const field = ctx.get_web().getList(`${window._spPageContextInfo.webAbsoluteUrl}/Lists/Endringsforslag`).get_fields().getByInternalNameOrTitle(fieldName);
            const choiceField = ctx.castTo(field, window.SP.FieldChoice);
            ctx.load(choiceField);

            ctx.executeQuery()
            .then(() => {
                const options = choiceField.get_choices().map((opt) => {
                    return {
                        key: opt,
                        text: opt,
                    };
                });
                return dispatch({
                    type: FIELD_OPTION,
                    payload: {
                        options,
                        field: fieldName,
                    },
                });
            })
            .catch((sender, args) => {
                return dispatch({
                    type: FIELD_OPTION_ERROR,
                    payload: {
                        field: fieldName,
                        error: `Error fetching ${fieldName}; ${args && args.get_message() || ''}`,
                    },
                });
            });
        });
    };
}



// WEBPACK FOOTER //
// ./src/actions/optionsActions.js